import { themeAtom } from "../../shared/atoms";
import Rating, { RatingLabel } from "../../shared/components/Rating";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface Props {
  EEXI: number | null;
  EEOI: number | null;
  CII: RatingLabel | "Not Available";
}

export const Efficiency: React.FC<Props> = ({ EEXI, EEOI, CII }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div
      className={twMerge(
        "mb-4 rounded-lg p-4 shadow-md",
        theme.home.tailwind.panelBackground,
        theme.home.tailwind.textDefault,
      )}
    >
      <h1 className="mb-4 text-2xl font-bold">Efficiency</h1>
      <div className={twMerge("grid grid-cols-4 gap-4", theme.vesselDetails.fields)}>
        <div className="py-2">
          <div className="text-xs">CII</div>
          <div className="relative text-sm">{CII === "Not Available" ? `N/A` : <Rating label={CII} />}</div>
        </div>

        <div className="py-2">
          <div className="text-xs">EEXI</div>
          <div className="text-sm">{EEXI ? `${EEXI} gCO2/tonne-nm` : "N/A"}</div>
        </div>

        <div className="py-2">
          <div className="text-xs">EEOI</div>
          <div className="text-sm">{EEOI ? `${EEOI} gCO2/tonne-mile` : "N/A"}</div>
        </div>
      </div>
    </div>
  );
};
